import { render } from "./Corporation.vue?vue&type=template&id=6734635e"
import script from "./Corporation.vue?vue&type=script&lang=js"
export * from "./Corporation.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src834291806/src/oms-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__